import script from "./policy-tabs-container.vue?vue&type=script&setup=true&lang=js"
export * from "./policy-tabs-container.vue?vue&type=script&setup=true&lang=js"

import "./policy-tabs-container.vue?vue&type=style&index=0&id=08921abc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08921abc"]])

export default __exports__